
import React from 'react';
import ReactMarkdown from 'react-markdown';
import config from '../../constant/config';

import './AIChat.css';

class AIChat extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      question: '',
      messages: [],
      loading: false,
    };
  }

  handleChange = (event) => {
    this.setState({
      question: event.target.value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const question = this.state.question.trim();

    if (!question || this.state.loading) {
      return;
    }

    this.setState((prevState) => ({
      messages: [
        ...prevState.messages,
        {
          role: 'user',
          content: question,
        },
      ],
      question: '',
      loading: true,
    }));

    try {
      const response = await fetch(`${config.apiURL}/ai/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          question,
        }),
      });

      if (!response.ok) {
        throw new Error('AI request failed');
      }

      const data = await response.json();

      this.setState((prevState) => ({
        messages: [
          ...prevState.messages,
          {
            role: 'assistant',
            content: data.answer,
            summary: data.summary,
          },
        ],
        loading: false,
      }));
    } catch (error) {
      console.error('AI chat error:', error);

      this.setState((prevState) => ({
        messages: [
          ...prevState.messages,
          {
            role: 'assistant',
            content: 'Sorry, I could not process your request.',
          },
        ],
        loading: false,
      }));
    }
  };

  render() {
    const {
      question,
      messages,
      loading,
    } = this.state;

    return (
      <div className="ai-chat">

        {/* Header */}
        <div className="ai-chat-header">
          <div>
            <div className="ai-chat-title">
              ACTIFY AI Assistant
            </div>

            <div className="ai-chat-subtitle">
              Ask questions about Actify content
            </div>
          </div>
        </div>

        {/* Messages */}
        <div className="ai-chat-messages">

          {messages.length === 0 && (
            <div className="ai-chat-empty">
              <div className="ai-chat-empty-icon">
                ✨
              </div>

              <div className="ai-chat-empty-title">
                How can I help you?
              </div>

              <div className="ai-chat-empty-text">
                Ask me anything about Actify content.
              </div>
            </div>
          )}

          {messages.map((message, index) => (
            <div
              key={index}
              className={`ai-chat-message ${message.role}`}
            >
              <div className="ai-chat-message-content">

                {message.role === 'assistant' && (
                  <div className="ai-chat-message-role">
                    AI
                  </div>
                )}

                {message.role === 'user' && (
                  <div className="ai-chat-message-role">
                    You
                  </div>
                )}

                <div className="ai-chat-message-text">
                  {message.role === 'assistant' ? (
                    <>
                      <ReactMarkdown>
                        {message.content}
                      </ReactMarkdown>

                      {message.summary && (
                        <div className="ai-chat-summary">

                          <div className="ai-chat-summary-title">
                            Summary
                          </div>

                          <div className="ai-chat-summary-content">
                            <ReactMarkdown>
                              {message.summary}
                            </ReactMarkdown>
                          </div>

                        </div>
                      )}
                    </>
                  ) : (
                    <div>
                      {message.content}
                    </div>
                  )}
                </div>

              </div>
            </div>
          ))}

          {loading && (
            <div className="ai-chat-message assistant">

              <div className="ai-chat-message-content">

                <div className="ai-chat-message-role">
                  AI
                </div>

                <div className="ai-chat-thinking">
                  <span>Thinking</span>
                  <span className="ai-chat-dots">...</span>
                </div>

              </div>

            </div>
          )}

        </div>

        {/* Input */}
        <form
          onSubmit={this.handleSubmit}
          className="ai-chat-input"
        >
          <input
            type="text"
            value={question}
            onChange={this.handleChange}
            placeholder="Ask something..."
            disabled={loading}
          />

          <button
            type="submit"
            disabled={loading || !question.trim()}
            aria-label="Send message"
          >
            ➤
          </button>
        </form>

      </div>
    );
  }
}

export default AIChat;

